import { render, staticRenderFns } from "./WalletCreditingPortal.vue?vue&type=template&id=8d5130ec&scoped=true&"
import script from "./WalletCreditingPortal.vue?vue&type=script&lang=js&"
export * from "./WalletCreditingPortal.vue?vue&type=script&lang=js&"
import style0 from "./WalletCreditingPortal.vue?vue&type=style&index=0&id=8d5130ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5130ec",
  null
  
)

export default component.exports